document.addEventListener('DOMContentLoaded', () => {
  const navContainer = document.querySelector('.header-main-nav');
  if (!navContainer) return;

  const navItems = Array.from(navContainer.querySelectorAll('li'));
  const topLevelItems = navItems.filter(item => item.closest('.header-main-nav-sub-container') === null);

  function getFocusable(item) {
    return item?.querySelector('a, button');
  }

  function openSubmenu(button) {
    const submenuId = button.getAttribute('aria-controls');
    const submenu = submenuId && document.getElementById(submenuId);

    document.querySelectorAll('.header-main-nav-sub-container').forEach((otherSubmenu) => {
      if (otherSubmenu !== submenu) {
        const toggle = document.querySelector(`button[aria-controls="${otherSubmenu.id}"]`);
        if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
          closeSubmenu(toggle);
        }
      }
    });

    if (submenu) {
      const parentLi = button.closest('li');
      parentLi?.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      submenu.removeAttribute('inert');
      submenu.setAttribute('aria-hidden', 'false');

      const firstSubLink = submenu.querySelector('a, button');
      if (firstSubLink) firstSubLink.focus();
    }
  }

  function closeSubmenu(button) {
    const submenuId = button.getAttribute('aria-controls');
    const submenu = submenuId && document.getElementById(submenuId);
    if (submenu) {
      const parentLi = button.closest('li');
      parentLi?.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      submenu.setAttribute('inert', '');
      submenu.setAttribute('aria-hidden', 'true');
      button.focus();
    }
  }

  // Handle top-level items
  topLevelItems.forEach((item, index) => {
    const button = item.querySelector('button[aria-controls]');
    const link = item.querySelector('a');
    const mainTarget = button || link;
    if (!mainTarget) return;

    mainTarget.addEventListener('keydown', (e) => {
      const prev = topLevelItems[index - 1];
      const next = topLevelItems[index + 1];

      switch (e.key) {
        case 'ArrowUp':
          e.preventDefault();
          if (prev) {
            const focusPrev = getFocusable(prev);
            if (focusPrev) focusPrev.focus();
          }
          break;

        case 'ArrowDown':
          e.preventDefault();
          if (next) {
            const focusNext = getFocusable(next);
            if (focusNext) focusNext.focus();
          }
          break;

        case 'ArrowRight':
        case 'Enter':
          if (button) {
            e.preventDefault();
            openSubmenu(button);
          }
          break;

        case 'ArrowLeft':
          if (button) {
            e.preventDefault();
            closeSubmenu(button);
          }
          break;
        
        case 'Escape':
          if (button && button.getAttribute('aria-expanded') === 'true') {
            e.preventDefault();
            closeSubmenu(button);
          }
          break;
      }
    });

    if (button) {
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          closeSubmenu(button);
        } else {
          openSubmenu(button);
        }
      });
    }
  });

  // Handle submenu navigation
  const submenus = document.querySelectorAll('.header-main-nav-sub-container');
  submenus.forEach((submenu) => {
    const links = Array.from(submenu.querySelectorAll('a, button'));
    if (links.length === 0) return;

    submenu.addEventListener('keydown', (e) => {
      const currentIndex = links.indexOf(document.activeElement);

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          links[(currentIndex + 1) % links.length].focus();
          break;

        case 'ArrowUp':
          e.preventDefault();
          links[(currentIndex - 1 + links.length) % links.length].focus();
          break;

        case 'Escape':
        case 'ArrowLeft': {
          e.preventDefault();
          const toggle = document.querySelector(`button[aria-controls="${submenu.id}"]`);
          if (toggle) closeSubmenu(toggle);
          break;
        }
      }
    });
  });
});
